import { Box, SxProps } from '@mui/material';
import React from 'react';

function Container({ children }: { children: React.ReactNode }) {
  return (
    <Box
      sx={{
        width: '100vw',
        height: '100vh',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      {children}
    </Box>
  );
}

function Content({ children, sx }: { children: React.ReactNode; sx?: SxProps }) {
  return <Box sx={{ flex: '1 1 auto', display: 'flex', ...sx }}>{children}</Box>;
}

const Layout = {
  Container,
  Content,
};

export default Layout;
